import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, change, getFormSyncErrors, reset } from 'redux-form';
import { IApplicationState } from 'ducks/reducers';
import {
    actions as operationActions,
} from 'ducks/uiOperations';
import IWidgetConfigurationDialogProps from './WidgetConfigurationDialog.properties';
import WidgetConfigurationDialog from './WidgetConfigurationDialog';
import { bindActionCreators, Dispatch } from 'redux';
import { selectors as staffSelectors } from 'ducks/staff';
import { selectors as dashboardMaintenanceSelectors } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

const params = new URLSearchParams(location.search);

type IStateProps = Pick<IWidgetConfigurationDialogProps,
    'formValues' | 'formSyncErrors' | 'staff' | 'selectedDashboardId'
>;
const DYNAMIC_EXTRACT_FORM = 'dynamicExtractForm';
const mapStateToProps = (state: IApplicationState): IStateProps => ({
    selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
    formValues: getFormValues(DYNAMIC_EXTRACT_FORM)(state),
    formSyncErrors: getFormSyncErrors(DYNAMIC_EXTRACT_FORM)(state),
    staff: staffSelectors.staff(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeOperationMode: operationActions.changeOperationMode,
        changeFormFieldValue: (fieldName: string, fieldValue: any) => change(DYNAMIC_EXTRACT_FORM, fieldName, fieldValue),
        resetForm: () => reset(DYNAMIC_EXTRACT_FORM),
    },
    dispatch);

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)((props: any) => {

    return (<WidgetConfigurationDialog {...props} />);
});

export default ConnectedComponent;
